<template>
    <div class='component-page'>
        <!--文本搜索位置-->
        <div class="filter-area">
            <Row style='text-align: center;' class='add_search'>
                <Col span="4">
                    <Input search v-model="formItem.sys_order_num" placeholder="输入订单号" @on-search="handleSearch" style="width:100%;" />
                </Col>
                <Col span="4">
                    <Input search v-model="formItem.phone" placeholder="输入手机号" @on-search="handleSearch" style="width:100%;" />
                </Col>
            </Row>
        </div>
        <!--下拉搜索位置-->
        <div class="edittable-table-height-con">
            <Row class='search-select'>
                <Col span="8">
                    <span>时间：</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='start_time' style="width: 130px;display:inline-block" @on-change='changStarttime'></Date-picker>
                    <span style="margin: 0 10px;">至</span>
                    <Date-picker type="date" placeholder="选择日期" v-model='end_time' style="width: 130px;display:inline-block" @on-change='changEndtime'></Date-picker>
                </Col>
                <!--
                <Col span='14'>
                    <span>所在地区：</span>
                    
                    <Select v-model="formItem.province_id" placeholder="请选择" @on-change="changeProvince" clearable style="width:160px">
                        <Option v-for="item in provinceList" :value="item.province_id" :key="item.province_id">{{ item.province_name }}</Option>
                    </Select>
                    <Select ref='citySelect' v-model="formItem.city_id" placeholder="请选择" @on-change="changeCity" clearable style="width:160px;">
                        <Option v-for="item in cityList" :value="item.city_id" :key="item.city_id">{{ item.city_name }}</Option>
                    </Select>
                    <Select ref='areaSelect' v-model="formItem.area_id" placeholder="请选择" @on-change="changeArea" clearable style="width:160px">
                        <Option v-for="item in areaList" :value="item.area_id" :key="item.area_id">{{ item.area_name }}</Option>
                    </Select>
                </Col>
                -->
                <Col span='4'>
                    <Select v-model="formItem.pay_status" placeholder="订单状态" @on-change="handleSearch" clearable style="width:200px">
                        <Option v-for="item in statusList" :value="item.id" :key="item.id">{{ item.name }}</Option>
                    </Select>
                </Col>          
            </Row>
            

            <Table stripe border :columns="editIncellColumns" :data="editIncellData"></Table>
            <div style="margin: 20px 0 10px 0 ;overflow: hidden;">
                <Page style='float: right'  size="small" :total="total_count" :page-size="formItem.page_size" :current="formItem.page" @on-change="changePage" />
            </div>
        </div>
    
        <Modal v-model="detailsModal" width="750" title="详情">
            <div class='details-box'>
                <p><span>订单号：{{detailsFrom.sys_order_num}}</span><span>订单状态：<span v-if='detailsFrom.pay_status==0'>未支付</span><span v-if='detailsFrom.pay_status==0'>已支付</span></span></p>
                <p><span>下单时间：{{detailsFrom.create_at}}</span><span>支付时间：{{detailsFrom.pay_at}}</span></p>
                <p style='font-size:14px;line-height:40px;font-weight:900'>买家信息</p>
                <p><span>姓名：{{detailsFrom.nickname}}</span><span>手机号：{{detailsFrom.phone}}</span></p>
    
            </div>
            <div v-if='refundStatus' class='details-box'>
                <p style='font-size:14px;line-height:40px;font-weight:900'>退款信息</p>
                <p><span>经办人：{{detailsFrom.refund_agent}}</span><span>退款金额：{{detailsFrom.refund_price}}</span></p>
                <p><span>退款时间：{{detailsFrom.create_at}}</span></p>
                <p>退款说明：{{detailsFrom.refund_desc}}</p>
            </div>
            <div class='details-box'>
                <p style='font-size:14px;line-height:40px;font-weight:900'>商品信息</p>
                <p><span>名称：{{detailsFrom.name}}</span><span>金额：{{detailsFrom.money}}</span><span v-if='detailsFrom.type==2'>袋鼠币：{{detailsFrom.goods_price}}</span><span v-if='detailsFrom.type==1'>价格：{{detailsFrom.goods_price}}</span></p>
                <img :src="detailsFrom.cover_url" alt="" style='width:150px;'>
            </div>
            <div slot="footer">
                <Button type='primary' shape="circle" ghost @click='cancel'>关闭</Button>
            </div>
        </Modal>
        <!--提醒弹层-->
        <Modal v-model="remindModal" width="440" class='remind'>
            <div class='remindContent'>
                {{remindContent}}
            </div>
            <div slot="footer">
                <Button type='primary' ghost shape="circle" @click='cancelRemain'>取消</Button>
                <Button type="primary" shape="circle" @click="primaryRemind">确定</Button>
            </div>
        </Modal>
    </div>
</template>

<style lang="css">
    @import "../common.css";
</style>

<style>
    .ivu-select-dropdown {
        top: 30px!important;
    }
    
    .ivu-select {
        position: relative;
    }
    
    .details-box {
        line-height: 30px;
        font-size: 12px;
    }
    
    .details-box span {
        margin-right: 50px;
    }
    
    .school {
        float: left;
        font-size: 14px;
        line-height: 30px;
        margin-right: 10px;
        cursor: pointer;
        padding: 0 10px;
    }
    
    .school.active {
        background: #ddd;
    }
    
    .active {
        border-bottom: 2px solid #000;
        padding-bottom: 10px;
    }
    
    .type-list {
        cursor: pointer;
    }
</style>
<script>
    import {
        fetchTableList,
        fetchInfo,
        setPay
      
    } from '@/api/orderList'

    export default {
        name: 'user-components',
        data () {
            return {
                total_count: 0, //列表总条数
                amount:'',
                formItem:{
                    page: 1, //列表当前页数
                    page_size: 10,
                    pay_status: '', 
                    start_time: '',
                    end_time: '',
                    phone:'',
                    sys_order_num:'',

                },
                id:'',
                start_time: '',
                end_time: '',
                detailsModal:false,//详情弹框
                detailsFrom:{

                },
                remindContent:'',//提醒内容
                remindModal:false,//提醒弹层状态
                statusList:[
                    {id:1,name:'已支付'},
                    {id:0,name:'未支付'},
                ],
                refundStatus:false,
                schoolColumns:[
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                    {
                        title: '学校名称',
                        align: 'center',
                        key: 'school_name',

                    },
                    {
                        title: '学院人数',
                        align: 'center',
                        key: 'student_num',
                    },

                ],
                schoolData:[],
                provinceList:[],
                cityList:[],
                areaList:[],
                editIncellColumns: [
                    {
                        title: '序号',
                        align: 'center',
                        type: 'index',
                        width: 80,
                    },
                
                    {
                        title: '订单号',
                        align: 'center',
                        key: 'sys_order_num',

                    },
                    {
                        title: '手机号',
                        align: 'center',
                        key: 'phone',
                    },
                    {
                        title: '姓名',
                        align: 'center',
                        key: 'nickname',
                        
                    },
                    {
                        title: '订单金额',
                        align: 'center',
                        key: 'money',
                    },
                    {
                        title: '下单时间',
                        align: 'center',
                        key: 'create_at',
                        width:150,
                    },
                     {
                        title: '支付时间',
                        align: 'center',
                        key: 'pay_at',
                        width: 150,
                    },
                    {
                        title: '支付状态',
                        align: 'center',
                        key: 'pay_status',
                        render: (h, params) => {
                            if(params.row.pay_status==0){
                                return h('span', '未支付')
                            }else{
                                return h('span', '已支付')
                            }
                        }
                    },
                   
                    {
                        title: '操作',
                        align: 'center',
                        key: 'action',
                        width: 160,
                        render: (h, params) => {
                            if(params.row.pay_status==0){
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'info',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.seeInfo(params.row.id)
                                            }
                                        }
                                    }, '查看详情'),
                                    h('Button', {
                                        props: {
                                            type: 'info',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.pay(params.row.id,params.row.money,params.row.name)
                                            }
                                        }
                                    }, '支付'),
                                  
                                ])
                            }else{
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'info',
                                            size: 'small',
                                            ghost: true

                                        },
                                        style: {
                                            marginRight: '5px'
                                        },
                                        on: {
                                            click: () => {
                                                this.seeInfo(params.row.id)
                                            }
                                        }
                                    }, '查看详情'),
                                  
                                ])
                            }
                            
                        }
                    }
                
                ],//列表
                editIncellData: [],//列表数据
            };
        },
        methods: {
            //获取列表数据
            getData () {
                this.$Loading.start();
                fetchTableList(this.formItem).then(res => {
                    res=res.data;
                    this.$Loading.finish();
                    if(res.code == 200){
                        this.editIncellData = res.data.list;
                        this.total_count = parseInt(res.data.total_count);
                        this.amount=res.data.school_money;
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },
            seeInfo(id){
                fetchInfo({
                    id:id
                }).then(res => {
                    res=res.data;
                    if(res.code == 200){
                        this.detailsFrom = res.data;
                        this.detailsModal=true;
                    }else if(res.code == 14001){
                        this.$Message.error(res.msg);
                        this.$store.dispatch('handleLogOut').then(res => {
                            this.$store.commit('clearOpenedSubmenu')
                            this.$router.push({
                                name: 'login'
                            })
                        })
                    }else{
                        this.$Message.error(res.msg);
                    }
                })
            },

            pay(id,money,name){
                this.id = id;
                this.remindContent = '确定支付该订单吗？剩余金额：'+this.amount+' 扣除金额：'+money+' 支付项目：'+name;
                this.remindModal = true;
            },
            //提醒弹出层的确定事件
            primaryRemind(){
                    setPay({
                        id:this.id,
                     
                    }).then(res => {
                        res=res.data;
                        if(res.code==200){
                            this.getData();
                            this.remindModal=false;
                        }else if(res.code == 14001){
                            this.$Message.error(res.msg);
                            this.$store.dispatch('handleLogOut').then(res => {
                                this.$store.commit('clearOpenedSubmenu')
                                this.$router.push({
                                    name: 'login'
                                })
                            })
                        }else{
                            this.$Message.error(res.msg);
                        }
                    })
                
            },
             // 改变开始时间
            changStarttime(time) {
                if (time == '') {
                    this.formItem.start_time = '';
    
                } else {
                    this.formItem.start_time = new Date(time).getTime() / 1000 - 28800;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 改变结束时间
            changEndtime(time) {
                if (time == '') {
                    this.formItem.end_time = '';
    
                } else {
                    this.formItem.end_time = new Date(time).getTime() / 1000 + 57600;
                }
                this.formItem.page = 1;
                this.getData();
            },
            // 取消关闭弹层
            cancel(){
                this.addModel=false;
                this.detailsModal=false;
            },
           
            //搜索框搜索
            handleSearch () {
                this.formItem.page = 1;
                this.getData();
            },
            // 关闭提醒弹出
            cancelRemain(){
                this.remindModal = false; 
            },
            //改变当前页码
            changePage (row) {
                this.formItem.page = row;
                this.getData();
            },
            
        },
        created () {
            this.getData();
        }
    };
</script>
